// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"0a7030ff7c360f6dee99","655":"e760cff211bad8506805"}[chunkId] + ".js";
};